<!--
  评论
  lovi 2020-06-19
-->
<template>
  <div>
    <div class="comment" v-for="(item, index) in commentList" :key="index">
      <div class="avatar">
        <img :src="httpUrl + item.avatar" />
      </div>
      <div class="info">
        <div class="title">
          <span class="name">{{ item.username }}</span>
          <span class="time text-gray">{{ item.createtime }}</span>
        </div>
        <div class="content">{{ item.evaluation }}</div>
        <div class="image-wrap" v-if="item.comments_img.length">
          <div
            class="image"
            @click="clickImage(item.comments_img, imageIndex)"
            v-for="(image, imageIndex) in item.comments_img"
            :key="imageIndex"
          >
            <img :src="httpUrl + image.url" />
          </div>
        </div>
        <div class="revert" v-if="item.reply != ''">
          {{ $t("life.merchantReply") }}：{{ item.reply }}
        </div>
      </div>
    </div>
    <van-image-preview
      v-model="imageFlag"
      :images="images"
      :startPosition="imagesCur"
      @change="onChange"
    >
      <template v-slot:index>{{ imagesIndex }}</template>
    </van-image-preview>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      shopId: "",
      commentList: [],
      imageFlag: false,
      images: [],
      imagesCur: 0,
      imagesIndex: 1
    };
  },
  created() {
    this.shopId = this.$route.query.shopId;
    this.getStoreComments();
  },
  mounted() {},
  computed: {},
  methods: {
    clickImage(data, index) {
      // 点击查看图片
      this.imageFlag = true;
      this.imagesCur = index;
      this.images = [];
      for (let i = 0; i < data.length; i++) {
        this.images.push(this.httpUrl + data[i].url);
      }
      console.log("images", this.images);
    },
    onChange(index) {
      // 点击默认图片索引
      console.log("onChange", index + 1);
      this.imagesIndex = index + 1;
    },
    getStoreComments() {
      let vm = this;
      let params = {};
      params.shop_id = vm.shopId;
      vm.$post("/app/store/getStoreComments", params, { loading: true }).then(
        res => {
          console.log("getStoreComments", res);
          vm.commentList = res.list;
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.comment {
  display: flex;
  justify-content: flex-start;
  position: relative;
  padding: 12px 20px;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 60px;
    right: 0;
    border-bottom: 1.1px solid #eaeaea;
  }
  .avatar {
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info {
    flex: 1;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      line-height: 1;
      .name {
        font-size: 12px;
      }
      .time {
        font-size: 10px;
      }
    }
    .content {
      font-size: 14px;
      line-height: 1.5;
    }
    .image-wrap {
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      .image {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 54px;
        height: 54px;
        border-radius: 4px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .revert {
      margin-top: 5px;
      padding: 4px;
      line-height: 1.5;
      background: #eaeaea;
      border-radius: 4px;
    }
  }
}
</style>
